module.exports = require('./log')



// WEBPACK FOOTER //
// ./src/plugins/log/index.js